import { jsx as t } from "react/jsx-runtime";
import { createContext as n, useContext as P } from "react";
const o = n(
  void 0
);
function u({
  children: r,
  pageProps: e
}) {
  return /* @__PURE__ */ t(o.Provider, { value: e, children: r });
}
function p() {
  return P(o);
}
export {
  u as PagePropsProvider,
  p as usePageProps
};
